import React from 'react'

import Icon, { Props } from './Icon'

const IconCheckmark: React.FC<Props> = (props) => {
  const { variant, ...iconProps } = props
  return (
    <Icon
      variant={variant || 'white'}
      title=""
      viewBox="0 0 90.325 69.421"
      {...iconProps}
    >
      <path
        d="M33.574 42.187c-3.992-3.685-10.44-10.44-14.738-14.738-4.299-3.992-7.062-.614-12.282 4.913-5.834 5.834 0 8.904 8.29 17.194L29.89 64.602c5.527 4.913 10.132-2.456 17.502-9.518l30.09-30.397C87 15.476 89.15 15.476 81.474 8.107c-6.755-7.062-6.448-7.062-17.194 3.992-4.914 4.604-29.171 29.167-30.706 30.088z"
        role="presentation"
      />
    </Icon>
  )
}

export default IconCheckmark
